"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEthersRpcProvider = exports.normalizeChainIdAsNumber = exports.OptimizedSingleChainRpcProvider = void 0;
const ethers_1 = require("ethers");
const memoizee_1 = __importDefault(require("memoizee"));
// an optimized provider to reduce unnecessary pulling and network requests.
class OptimizedSingleChainRpcProvider extends ethers_1.providers.JsonRpcProvider {
    async getNetwork() {
        if (this._network) {
            return Promise.resolve(this._network);
        }
        return super.getNetwork();
    }
}
exports.OptimizedSingleChainRpcProvider = OptimizedSingleChainRpcProvider;
// takes in chain id as either "0x1" or "1" and returns a number "1"
const normalizeChainIdAsNumber = (chainId) => {
    if (chainId.startsWith("0x")) {
        return Number(chainId.replace("0x", ""));
    }
    return Number(chainId);
};
exports.normalizeChainIdAsNumber = normalizeChainIdAsNumber;
// creates a provider for making requests to an RPC node
// the provider is memoized to prevent unnecessary network requests
exports.createEthersRpcProvider = (0, memoizee_1.default)((options) => {
    const network = ethers_1.providers.getNetwork(options.chainId);
    const url = ethers_1.providers.InfuraProvider.getUrl(network, {
        projectId: options.infura.projectId,
        projectSecret: options.infura.projectSecret,
    });
    return new OptimizedSingleChainRpcProvider(url, network);
}, {
    normalizer: (args) => {
        const options = args[0];
        return String(options.chainId);
    },
});
